import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from './Roundel.module.scss'

export const YoutubeRoundelIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 32,
  height = 32,
  className,
  ...rest
}) => {
  return (
    <Icon
      className={classnames(styles.youtube, className)}
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <path
        d="M10.3,0.2 C11.6,0.2 16.4,0.2 17.7,0.6 C18.6,0.9 19.3,1.6 19.5,2.5 C19.9,4 19.9,6.9 19.9,7.5 L19.9,7.7 C19.9,8.2 19.9,11.2 19.5,12.7 C19.3,13.6 18.6,14.3 17.7,14.6 C16.3,15 10.8,15 10,15 L10,15 C9.2,15 3.7,15 2.3,14.6 C1.4,14.3 0.7,13.6 0.5,12.6 C0.223932736,11.0151118 0.0900668755,9.40872152 0.1,7.8 L0.1,7.3 C0.1,6.5 0.1,3.9 0.5,2.5 C0.7,1.5 1.5,0.9 2.3,0.6 C3.6,0.2 8.3,0.2 9.7,0.2 L10.3,0.2 Z M7.9,5.2 L7.9,11.2 L12.9,8.2 L7.9,5.2 L7.9,5.2 Z"
        data-testid="roundel-icon-youtube"
        fill="#ffffff"
        className={styles.white}
        transform="translate(6.000000, 8.000000)"
      />
    </Icon>
  )
}
